import React, { useMemo } from 'react';
import { SlideObject } from '../types';
import { ThumbnailFrame } from '../ui';
import { componentPreviewCanvas, slideFromComponent } from './componentPreview';
import StaticSlideView from './StaticSlideView';

interface GlobalComponentPreviewProps {
  id: string;
  objects: SlideObject[];
}

const GlobalComponentPreview: React.FC<GlobalComponentPreviewProps> = ({ id, objects }) => {
  const slide = useMemo(() => slideFromComponent(id, objects), [id, objects]);
  const canvas = useMemo(() => componentPreviewCanvas(objects), [objects]);

  return (
    <ThumbnailFrame>
      <StaticSlideView
        slide={slide}
        contentWidth={canvas.width}
        contentHeight={canvas.height}
      />
    </ThumbnailFrame>
  );
};

export default GlobalComponentPreview;
